import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./SingleColumnWithControls.module.scss";
import classNames from "classnames/bind";
import useRouteLoading from "../../hooks/useRouteLoading";

import { useInView } from "react-intersection-observer";

const cx = classNames.bind(styles);

export const slotNameMap = {
  HEADER: "header",
  BANNER: "banner",
  TOP: "top",
  ACCESSORY: "accessory",
  MAIN_TOP: "main-top",
  STICKY_BAR: "sticky-bar",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function SingleColumnWithControls(props: PageProps) {
  const isRouteLoading = useRouteLoading();
  const { ref: stickySentinelRef, inView: stickySentinelInView } = useInView({
    initialInView: true,
  });

  return (
    <div data-layout="SingleColumnWithControls" className={styles.page}>
      <Slot {...props} name={slotNameMap["HEADER"]} sizes="100vw" />

      <main className={styles.main}>
        <div className={styles.container}>
          <Slot
            {...props}
            name={slotNameMap["BANNER"]}
            sizes="100vw"
            className={styles.banner}
          />

          <Slot
            {...props}
            name={slotNameMap["TOP"]}
            sizes="100vw"
            className={styles.top}
          />
        </div>
        <div ref={stickySentinelRef} className={styles.stickySentinel} />
        <div
          className={cx("stickyContainer", {
            isStuck: !stickySentinelInView,
            "u-loading": isRouteLoading,
          })}
        >
          <Slot
            {...props}
            name={slotNameMap["STICKY_BAR"]}
            className={cx("stickyBar", { isStuck: !stickySentinelInView })}
            sizes="100vw"
          />
        </div>
        <div className={styles.content}>
          <Slot
            {...props}
            name={slotNameMap["MAIN"]}
            sizes="100vw"
            className={cx("mainSlot", {
              "u-loading": isRouteLoading,
            })}
          />
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} sizes="100vw" />
    </div>
  );
}
